import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(
  ({ className, type, error, helperText, ...props }, ref) => {
    return (
      <div className="flex flex-col w-full">
        <input
          disabled={props.disabled}
          type={type}
          className={cn(
            "font-sans flex h-[40px] w-full rounded-md border bg-primary-foreground px-3 py-1 text-sm text-foreground transition-colors border-card-border",
            "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
            "focus:outline-none focus:ring-0",
            className,
            error && "border-red-500" ,
            // "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          )}
          onWheel={(e) => e.target.blur()}
          ref={ref}
          {...props}
        />
        {helperText && (
          <span className="text-red-500 text-xs mt-1">{helperText}</span>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
